module.exports = __webpack_public_path__ + "static/media/hamburger.dc432e00.jpg";